var _circle, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.486,
    cy: 16.486,
    r: 16.486,
    fill: "url(#pause_svg__a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 12,
    x: 12,
    y: 10,
    fill: "#1B1D1F",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 12,
    x: 18,
    y: 10,
    fill: "#1B1D1F",
    rx: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "pause_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(11.03966 -5.20975 8.95605 18.9782 16.5 16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })))));
};
export default SvgPause;